import React, { useState, useEffect } from 'react';
import FormAction from './component/form-action';
import AdminPage from './pages/AdminPage';
import CustomerPage from './pages/CustomerPage';
import InfoPage from './pages/InfoPage';
import { useSelector } from 'react-redux';

const Container = () => {
  const [step, setStep] = useState(0);
  const { onBoardedStatus, onBoardDetails } = useSelector(({ form }) => form);

  useEffect(() => {
    if (onBoardedStatus) {
      handleNext();
    }
  }, [onBoardedStatus]);

  const handleBack = () => setStep((stp) => stp - 1);
  const handleNext = () => setStep((stp) => stp + 1);

  return (
    <>
      {step === 0 && <AdminPage key={step} />}
      {step === 1 && <CustomerPage key={step} />}
      {step === 2 && <InfoPage key={step} data={onBoardDetails} />}
      {step !== 2 && (
        <FormAction
          handleBack={handleBack}
          handleNext={handleNext}
          step={step}
        />
      )}
    </>
  );
};

export default Container;
